import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ErrorTost } from './ToastHelper';

const flattenObject = (obj, parent = '', res = {}) => {
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const propName = parent === 'notes' ? key : parent ? `${parent}.${key}` : key;
      
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        flattenObject(obj[key], propName, res);
      } else {
        res[propName] = obj[key];
      }
    }
  }
  return res;
};

export const downloadExcel = (jsonData, fileName = "data.xlsx") => {
  if (jsonData?.length) {
    const flattenedData = jsonData.map(item => flattenObject(item));

    const worksheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    };

    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
  } else {
    ErrorTost('No data to Download');
  }
};



const formatISTDate = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).replace(/-/g, '/');
};

const extractLegacyUserParts = (order) => {
  const rawUser = order?.user || '';
  const parts = typeof rawUser === 'string' ? rawUser.split('-') : [];

  return {
    name: parts[0] || '',
    email: parts[1] || '',
    phone: parts[2] || '',
    country: parts[3] || '',
    countryCode: parts[4] || '',
    timezone: order?.notes?.timezone || '',
  };
};

const extractUserData = (order) => {
  const details = order?.user_details || {};
  const legacy = extractLegacyUserParts(order);

  return {
    name:
      details?.name ||
      details?.full_name ||
      order?.notes?.name ||
      legacy.name ||
      'N/A',

    email:
      details?.email ||
      order?.notes?.email ||
      legacy.email ||
      'N/A',

    phone:
      details?.phone ||
      order?.notes?.phone ||
      legacy.phone ||
      'N/A',

    country:
      details?.country ||
      order?.notes?.country ||
      legacy.country ||
      'N/A',

    countryCode:
      details?.country_code ||
      order?.notes?.countryCode ||
      legacy.countryCode ||
      'N/A',

    timezone:
      details?.timezone ||
      order?.notes?.timezone ||
      legacy.timezone ||
      'N/A',
  };
};

export const downloadOrdersExcel = (orders, fileName = 'orders') => {
  if (!orders?.length) {
    return ErrorTost('No data to Download');
  }

  const cleanedData = orders.map((order, index) => {
    const user = extractUserData(order);

    return {
      'Sr No': index + 1,
      'Name': user.name,
      'Email': user.email,
      'Phone': user.phone,
      'Country Name': user.country,
      'Country Code': user.countryCode,
      'Timezone': user.timezone,
      'Course Purchased': order?.product_id || order?.notes?.course_title || 'N/A',
      'Amount': order?.amount ?? 'N/A',
      'Currency': order?.notes?.currency || 'INR',
      'Gateway': order?.gateway || order?.notes?.gateway || 'N/A',
      'Order ID': order?.order_id || 'N/A',
      'Transaction Status': order?.status || 'N/A',
      'Paid Date': formatISTDate(order?.createdAt),
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(cleanedData);
  worksheet['!cols'] = [
    { wch: 8 },
    { wch: 24 },
    { wch: 30 },
    { wch: 18 },
    { wch: 18 },
    { wch: 14 },
    { wch: 20 },
    { wch: 24 },
    { wch: 12 },
    { wch: 12 },
    { wch: 18 },
    { wch: 24 },
    { wch: 18 },
    { wch: 22 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Orders');

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
  });

  saveAs(blob, `${fileName}.xlsx`);
};